import { defineStore } from "pinia";
import { computed, ref } from "vue";

const useLoadingStore = defineStore(
	"loading",
	() =>
	{
		const loadingStack = ref<string[]>([]);

		const isKeyLoading = (...keys: string[]) =>
		{
			for (const key of keys)
			{
				if (loadingStack.value.findIndex(k => k === key) !== -1)
				{
					return true;
				}
			}
			return false;
		};
		const getLoadingStack = computed(() => loadingStack.value);
		const isLoading = computed(() => loadingStack.value.length > 0);

		function initLoadingKeys(...keys: string[])
		{
			for (const key of keys)
			{
				enableLoading(key);
			}
		}

		function enableLoading(...keys: string[])
		{
			for (const key of keys)
			{
				if (! loadingStack.value.includes(key))
				{
					loadingStack.value.push(key);
				}
			}
		}

		function disableLoading(...keys: string[]): void
		{
			for (const key of keys)
			{
				const index = loadingStack.value.indexOf(key);
				if (index !== -1)
				{
					loadingStack.value.splice(index, 1);
				}
			}
		}

		function resetStack(): void
		{
			loadingStack.value = [];
		}

		return {
			isLoading,
			isKeyLoading,
			getLoadingStack,
			loadingStack,

			initLoadingKeys,
			enableLoading,
			disableLoading,
			resetStack
		};
	},
);

export default useLoadingStore;
